import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const reportDetailService = {
    getAllReportDetails,
    getReportDetail,
    getReportDetailByReportID,
    updateReportDetail,
    createReportDetail,
    updateReportDetailStatus
};

const MODULE = {
    DETAIL: 'new-report-details',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllReportDetails(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.DETAIL}`, requestOptions)
}

export function getReportDetail(id) {
    return apiHelper(API_URL).get(`/${MODULE.DETAIL}/${id}`)
}

export function getReportDetailByReportID(id) {
    return apiHelper(API_URL).get(`/${MODULE.DETAIL}/${id}/report`)
}

export function updateReportDetail(data) {

    const requestOptions = {
        description: data.description,
    }

    return apiHelper(API_URL).put(`/${MODULE.DETAIL}/${data.id}`, requestOptions)
}

export function createReportDetail(data) {

    const requestOptions = {
        report_uuid: data.name,
    }

    data.packages.forEach((packageData, index) => {
        requestOptions.params[`package_uuids[${index}]`] = packageData;
    });

    data.services.forEach((service, index) => {
        requestOptions.params[`menu_service_uuids[${index}]`] = service;
    });

    return apiHelper(API_URL).post(`/${MODULE.DETAIL}`, requestOptions)
}

export function updateReportDetailStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.DETAIL}/${data.id}`, requestOptions)

}